import { getMaxWidthLine, expandText, mergeLines, shrinkText, MIN_FONT_SIZE } from '../../../utils/canvas';

type ManageFabricTextSizeProps = {
  textbox: fabric.Textbox;
  fixedWidth: number;
  maxLines: number;
  maxFontSize: number;
  onOverMaxLines: (fabricTextbox) => void;
  OnTextAdjustmentFinished?: (textbox: fabric.Textbox) => void;
};

export const manageFabricTextSize = ({
  textbox,
  fixedWidth,
  maxLines,
  maxFontSize,
  onOverMaxLines,
}: ManageFabricTextSizeProps) => {
  // If the number of lines is within the limit and the widest line is less than the fixed width,
  // try to expand the text (increase font size) as much as possible without exceeding constraints.
  const maxWidthLine = getMaxWidthLine(textbox);
  if (textbox.textLines.length <= maxLines && maxWidthLine < fixedWidth) {
    while (
      // If number of lines is less than maxlines
      textbox.textLines.length <= maxLines &&
      // AND if fontSize is defined
      textbox.fontSize &&
      // AND if fontSize is less than maxFontSize
      textbox.fontSize < maxFontSize &&
      maxWidthLine < fixedWidth
    ) {
      expandText(textbox, maxFontSize); // Increase font size if possible
    }
  }
  // If the number of lines exceeds the limit or the widest line is too wide,
  // shrink the text (reduce font size) and/or merge lines until it fits.
  if (textbox.textLines.length > maxLines || getMaxWidthLine(textbox) > fixedWidth) {
    const hasEndingNewLine = /\n$/.test(textbox.text || '');
    if (hasEndingNewLine) {
      mergeLines(textbox); // Remove trailing newlines by merging lines
    }
    while (textbox.textLines.length > maxLines || getMaxWidthLine(textbox) > fixedWidth) {
      shrinkText(textbox); // Reduce font size until it fits
      if (
        textbox.fontSize === MIN_FONT_SIZE &&
        (textbox.textLines.length > maxLines || getMaxWidthLine(textbox) > fixedWidth)
      ) {
        // If at minimum font size and still doesn't fit, remove characters and show a warning toast
        const textLength = textbox.text?.length || 0;
        const offset = textbox.selectionEnd || textLength;
        textbox.removeChars(offset - 1, offset); // Remove last character
        if (textbox.hiddenTextarea) {
          textbox.hiddenTextarea.value = textbox.text as string;
        }
        textbox.setSelectionStart(offset - 1);
        textbox.width = fixedWidth;

        onOverMaxLines(textbox);
      }
    }
  }
  textbox.width = fixedWidth; // Ensure textbox width is set to fixedWidth
  return textbox;
};
